import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ExtractedRowForm } from '../models/extraction-form-models';

@Injectable({
  providedIn: 'root',
})
export class TableFormArrayCache {
  private readonly tableFormArrayByDocumentId: Record<string, FormArray<ExtractedRowForm>> = {};

  getFormArray(cacheKey: string): FormArray<ExtractedRowForm> {
    return this.tableFormArrayByDocumentId[cacheKey];
  }

  setFormArray(cacheKey: string, formArray: FormArray<ExtractedRowForm>): void {
    this.tableFormArrayByDocumentId[cacheKey] = formArray;
  }

  existsFormArray(cacheKey: string): boolean {
    return cacheKey in this.tableFormArrayByDocumentId;
  }
}
